export const selectedViewType = ({ parsers }) => parsers.selectedViewType;
export const selectedExpressionNames = ({ parsers }) =>
  parsers.selectedExpressionNames;
